export class SiteDto {
    id: string = '';
    name: string = '';
    code: string = '';
    sequence: number = 0;
    invisible: number = 0;
    remarks: string = '';
    dataGroupId: string = '';
}
